// extracted by mini-css-extract-plugin
export var active = "teachers-and-coaches-v2-module--active--47883";
export var carouselLeftButtonWrapper = "teachers-and-coaches-v2-module--carouselLeftButtonWrapper--b6c3d";
export var carouselRightButtonWrapper = "teachers-and-coaches-v2-module--carouselRightButtonWrapper--0ddb6";
export var carouselWrapper = "teachers-and-coaches-v2-module--carousel-wrapper--a299d";
export var chevronIcon = "teachers-and-coaches-v2-module--chevronIcon--5411d";
export var contentWrapper = "teachers-and-coaches-v2-module--contentWrapper--59878";
export var image = "teachers-and-coaches-v2-module--image--c0c2c";
export var imageCaption = "teachers-and-coaches-v2-module--image-caption--316a4";
export var imageWrapper = "teachers-and-coaches-v2-module--image-wrapper--561af";
export var indicator = "teachers-and-coaches-v2-module--indicator--f9c3b";
export var introText = "teachers-and-coaches-v2-module--introText--3bdb1";
export var leftContent = "teachers-and-coaches-v2-module--leftContent--6483b";
export var quoteAuthorPosition = "teachers-and-coaches-v2-module--quoteAuthorPosition--2435b";
export var quoteMarks = "teachers-and-coaches-v2-module--quoteMarks--68dde";
export var rightContent = "teachers-and-coaches-v2-module--rightContent--546c8";
export var root = "teachers-and-coaches-v2-module--root--1b0e0";
export var slider = "teachers-and-coaches-v2-module--slider--4d26d";
export var teacherHolder = "teachers-and-coaches-v2-module--teacherHolder--7129a";
export var teacherName = "teachers-and-coaches-v2-module--teacherName--26ac4";
export var teacherNamePopup = "teachers-and-coaches-v2-module--teacherNamePopup--9094d";
export var teachers = "teachers-and-coaches-v2-module--teachers--70dd5";
export var teachersCard = "teachers-and-coaches-v2-module--teachersCard--a3630";
export var wrapper = "teachers-and-coaches-v2-module--wrapper--1fec6";